module.exports = "<svg viewBox=\"-10 -10 220 220\" [ngStyle]=\"{'width.px': width, 'height.px': width}\">\n  <path [ngStyle]=\"{'stroke': color}\" d=\"M200,100 C200,44.771525 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z\" stroke-dashoffset=\"0\"></path>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/latitude-ui/loading/loading.component.html
// module id = ./src/latitude-ui/loading/loading.component.html
// module chunks = main